// Utility to check if any required personal info field is empty
export function hasEmptyPersonalInfo(userDetails: UserDetails | null): boolean {
  if (!userDetails) return true;
  const requiredFields = [
    'firstName',
    'lastName',
    'mobile',
    'company',
    'city',
    'industry'
  ];
  return requiredFields.some(
    (field) =>
      !userDetails[field as keyof UserDetails] ||
      userDetails[field as keyof UserDetails] === ''
  );
}
